export const SET_RAISE_HAND = "SET_RAISE_HAND";
export const SET_LAYOUT_TYPE = "SET_LAYOUT_TYPE";